import { OgpApiService } from 'ogp/services/ogp-api-service';
import {
  WorkersAvailabilityPaginated,
  workersAvailabilityPaginatedSchema,
} from './availability-service.schema';
import {
  GetWorkerAvailabilityDto,
  GetWorkersAvailabilityDto,
  UpdateWorkersAvailabilityDto,
} from './availability-service.dto';

export type GetWorkersAvailabilityParams = {
  search: string | undefined;
  fromDate: string;
  pageParam: number;
  pageSizeParam: number;
};

export class AvailabilityService {
  constructor(private readonly ogpApiService: OgpApiService) {}

  public updateWorkerAvailability = async (
    updateDto: UpdateWorkersAvailabilityDto
  ): Promise<void> => {
    await this.ogpApiService.update({
      path: `availability/edit`,
      body: updateDto,
    });
  };

  public getWorkersAvailability = async (
    params: GetWorkersAvailabilityParams
  ): Promise<WorkersAvailabilityPaginated> => {
    const workersAvailability = await this.ogpApiService.get<GetWorkersAvailabilityDto>({
      path: `availability/workers`,
      params: {
        search: params.search,
        pageParam: params.pageParam,
        pageSizeParam: params.pageSizeParam,
        fromDate: params.fromDate,
      },
    });

    return workersAvailabilityPaginatedSchema.parse(workersAvailability);
  };

  public async getWorkerAvailability(
    workerId: string,
    fromDate: string,
    toDate: string
  ): Promise<GetWorkerAvailabilityDto> {
    return await this.ogpApiService.get<GetWorkerAvailabilityDto>({
      path: `availability/${workerId}`,
      params: {
        fromDate,
        toDate,
      },
    });
  }
}
